export default "__VITE_ASSET__tlUL10my__";